
export default {
  name: 'Meta',
  props: {
    categories: {
      type: Array,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    time: null,
  }),
  computed: {
    sanitizedCategories() {
      return this.categories.filter(
        (category) => category.slug !== 'uncategorized'
      )
    },
  },
  mounted() {
    // Permanently removed
    // this.time = this.$readingTime(this.content)
    this.time = null
  },
}
